import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import {
  adminCompactNavigation,
  adminNavigation,
  auditorNavigation,
  clientNavigation,
  compactNavigation,
  customerNavigation,
  defaultNavigation,
  futuristicNavigation,
  horizontalNavigation,
  mmrNavigation,
  salesManagerNavigation,
  salesRepCompactNavigation,
  salesRepNavigation } from 'app/mock-api/common/navigation/data';

@Injectable({
    providedIn: 'root'
})
export class NavigationMockApi {
    private readonly _compactNavigation: FuseNavigationItem[] = compactNavigation;
    private readonly _defaultNavigation: FuseNavigationItem[] = defaultNavigation;
    private readonly _futuristicNavigation: FuseNavigationItem[] = futuristicNavigation;
    private readonly _horizontalNavigation: FuseNavigationItem[] = horizontalNavigation;

    private readonly _adminNavigation: FuseNavigationItem[] = adminNavigation;
    private readonly _adminCompactNavigation: FuseNavigationItem[] = adminCompactNavigation;

    private readonly _customerNavigation: FuseNavigationItem[] = customerNavigation;
    private readonly _auditorNavigation: FuseNavigationItem[] = auditorNavigation;

    private readonly _salesRepNavigation: FuseNavigationItem[] = salesRepNavigation;
    private readonly _salesRepCompactNavigation: FuseNavigationItem[] = salesRepCompactNavigation;
    private readonly _salesManagerNavigation: FuseNavigationItem[] = salesManagerNavigation;

    private readonly _clientNavigation: FuseNavigationItem[] = clientNavigation;
    private readonly _mmrNavigation: FuseNavigationItem[] = mmrNavigation;


    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService) {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void {
        // -----------------------------------------------------------------------------------------------------
        // @ Navigation - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/common/navigation')
            .reply(() => {

                // Fill compact navigation children using the default navigation
                this._compactNavigation.forEach((compactNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if (defaultNavItem.id === compactNavItem.id) {
                            compactNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Fill futuristic navigation children using the default navigation
                this._futuristicNavigation.forEach((futuristicNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if (defaultNavItem.id === futuristicNavItem.id) {
                            futuristicNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Fill horizontal navigation children using the default navigation
                this._horizontalNavigation.forEach((horizontalNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if (defaultNavItem.id === horizontalNavItem.id) {
                            horizontalNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Return the response
                return [
                    200,
                    {
                        compact: cloneDeep(this._compactNavigation),
                        default: cloneDeep(this._defaultNavigation),
                        futuristic: cloneDeep(this._futuristicNavigation),
                        horizontal: cloneDeep(this._horizontalNavigation),
                        admin: cloneDeep(this._adminNavigation),
                        adminCompact: cloneDeep(this._adminCompactNavigation),
                        customer: cloneDeep(this._customerNavigation),
                        auditor: cloneDeep(this._auditorNavigation),
                        salesRep: cloneDeep(this._salesRepNavigation),
                        salesRepCompact: cloneDeep(this._salesRepCompactNavigation),
                        salesManager: cloneDeep(this._salesManagerNavigation),
                        client: cloneDeep(this._clientNavigation),
                        mmr: cloneDeep(this._mmrNavigation)
                    }
                ];
            });
    }
}
